// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__32AJh","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1e_ud"};